import ButtonBar from '../../Elements/ButtonBar'
import { useState } from "react";
import Modal from "./TrabajadoresModal";
import data from "./ListaTrabajadores";

const Employees = () => {
  const [imput, setImput] = useState("")
  const [filtro, setFiltro] = useState([])
  const [modal, setModal] = useState(false)
 
  const hadleModalToggle = () => {
    setModal(!modal)
  }

  const handleInput = (e) => {
    const filtroVacio = e.target.value
    setImput(filtroVacio)

    if(filtroVacio === "") {
      setFiltro([])
    }
  }

  const handleFiltro = () => {
    if (imput.trim() !== "") {
    const filtered = data.filter(
      socios => {
        return (
        socios
         .customer_name
         .toLowerCase()
         .includes(imput.toLowerCase()) ||
         socios
         .customer_lastname
         .toLowerCase()
         .includes(imput.toLowerCase()) ||
        socios
         .customer_id
         .toLowerCase()
         .includes(imput.toLowerCase()) 
        )	   
      }     
    )
    setFiltro(filtered)

    } else {
      
      setFiltro([])
    }
  }

  const menu_bar = [
    {
      title: 'Trabajador',
      buttons: [
        {
          label: 'Categorias',
          color: 'green',
          onClick: () => {
          },
        },
        {
          label: 'Crear Trabajador',
          color: 'green',
          onClick: hadleModalToggle
        },
        {
          label: 'Borrar',
          color: 'red',
          onClick: () => {
          },
        },
        {
          label: 'Actualizar',
          color: 'yellow',
          onClick: hadleModalToggle
        },
  
      ],
    },
  ];
  

  return (
    <div className='flex flex-col gap-4'>
      {menu_bar.map((menuItem, index) => (
        <ButtonBar
          key={index}
          title={menuItem.title}
          buttons={menuItem.buttons}
        />
      ))}
    <form onSubmit={(e) => {e.preventDefault(); handleFiltro(); }} >
      <div className="text-gray-700 font-medium w-full bg-white px-4 pt-3 pb-4 rounded-sm border border-gray-200 flex-1 z-50">
        <input 
          placeholder="Nombre, Apellidos, Nº Socio"
          value={imput}
          onChange={handleInput}
          
          />
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          type="submit"
          disabled={!imput}
        >
          Search
        </button>
      </div>
    </form>
    <div className="flex flex-row gap-4 w-full">
    <div className="bg-white px-4 pt-3 pb-4 rounded-sm border border-gray-200 flex-1">
      <strong className="text-gray-700 font-medium">Trabajadores</strong>
	  <div className="border-x border-gray-200 rounded-sm mt-3">
		<table className="w-full text-gray-700">
		  <thead className="bg-black">
			<tr>
			 <th></th>
			 <th className="text-white">Nombre</th>
			 <th className="text-white">Fecha</th>
			 <th className="text-white"></th>
			</tr>
			</thead>
			  <tbody className="border">
				{(imput === "" ? data : filtro).map((order) => (
				  <tr key={order.id}>
					<td className="border w-16">
					  <div
						className="h-16 w-16 rounded bg-sky-500 bg-cover bg-no-repeat bg-center"
						style={{ backgroundImage: 'url("https://source.unsplash.com/80x80?face")' }}
					  >
					  <span className="sr-only">{order.customer_name}</span>
					    </div>
						  </td>
						  <td className="border px-2">
							<div>#{order.customer_name} {order.customer_lastname} {order.customer_id}</div> 
						  </td>
							{/* <td>{format(new Date(order.date), 'dd MMM yyyy hh:mm')}</td> */}
						  <td className="border px-2">
							<button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
							  Editar
							</button>
						  </td>
						  <td className="border px-2">
							<button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
							  Checkout
							</button>
						  </td>
						</tr>
					 ))}
			</tbody>
		</table>
	  </div>
	</div>
      {/* <EmployeeMainBox input={imput} setInput={setImput} filtro={filtro} setFiltro={setFiltro} />*/}
      <Modal open={modal} handleClose={hadleModalToggle}></Modal>
    </div>
   </div>
   
  )
}

export default Employees


// const menu_bar = [
//   {
//     title: 'Trabajador',
//     buttons: [
//       {
//         label: 'Categorias',
//         color: 'green',
//         onClick: () => {
//           // Handle button click logic for "Crear Socio"
//         },
//       },
//       {
//         label: 'Crear Trabajador',
//         color: 'green',
//         onClick: () => {
//           // Handle button click logic for "Borrar"
//         },
//       },
//       {
//         label: 'Borrar',
//         color: 'red',
//         onClick: () => {
//           // Handle button click logic for "Actualizar"
//         },
//       },
//       {
//         label: 'Actualizar',
//         color: 'yellow',
//         onClick: () => {
//           // Handle button click logic for "Actualizar"
//         },
//       },

//     ],
//   },
// ];

// export default function Employees() {
//   return (
//     <div className='flex flex-col gap-4'>
//       {menu_bar.map((menuItem, index) => (
//         <ButtonBar
//           key={index}
//           title={menuItem.title}
//           buttons={menuItem.buttons}
//         />
//       ))}

//     <div className="flex flex-row gap-4 w-full">
//       <EmployeeMainBox />

        
//     </div>
// </div>
//   )
// }
